module.exports = __webpack_public_path__ + "img/arrow-static.4ba18dd8.png";